var App = App || {};

App.Base = (function ($) {
    'use strict';

    let bsElements = {};

    let modals = [];
    let modalFlag = false;

    const speedBump = $("#SpeedBump");
    let speedBumpExempt = typeof SpeedbumpData !== 'undefined' ? [...SpeedbumpData.ExemptList] : [];
    let serviceInterruptions = typeof SpeedbumpData !== 'undefined' && SpeedbumpData.ServiceInterruptions ? [...SpeedbumpData.ServiceInterruptions] : [];

    function Animations() {
        var supportsCssVariables = window.CSS && window.CSS.supports && window.CSS.supports("color", "var(--primary)"),
            itemQueue = [],
            delay = 50,
            queueTimer;

        function processItemQueue() {
            if (queueTimer) {
                return;
            }

            queueTimer = window.setInterval(function () {
                if (itemQueue.length) {
                    var animation = $(itemQueue).data("animation");

                    if (animation) {
                        $(itemQueue.shift())
                            .addClass("animate__" + animation)
                            .css("opacity", "1");

                        processItemQueue();
                    }

                } else {
                    window.clearInterval(queueTimer);

                    queueTimer = null;
                }
            }, delay);
        };

        if (supportsCssVariables) {
            $("html").addClass("supports-css-variables");

            setTimeout(function () {
                var $elements = $("[data-animation]");

                if ($elements.length) {
                    $elements.waypoint({
                        handler: function (direction) {
                            itemQueue.push(this.element);

                            processItemQueue();
                        },
                        offset: "100%"
                    });
                }
            }, 1);
        } else {
            setTimeout(function () {
                var $elements = $("[data-animation]");

                if ($elements.length) {
                    $.each($elements, function () {
                        $(this)
                            .css({
                                "opacity": "1",
                                "z-index": 0
                            })
                            .removeAttr("data-animation")
                            .removeClass("animate__animated");
                    });
                }
            }, 1)
        }
    };

    function Autofocus() {
        ["shown.bs.modal", "shown.bs.offcanvas"].forEach(function (eventName) {
            document.addEventListener(eventName, function (event) {
                var targetElement = event.target;
                var autofocusElement = targetElement.querySelector("[autofocus]");

                if (autofocusElement) {
                    autofocusElement.focus();
                }
            });
        });
    }

    function BsElements() {

        bsElements = {
            accElements: [...$(".accordion-item[id]")].map(x => `#${x.getAttribute("id")}`),
            tabElements: [...$(".nav-tabs .nav-item[id], .nav-pipes .nav-item[id]")].map(x => `#${x.getAttribute("id")}`),
            offcanvasElements: [...$(".offcanvas")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`)
        };

        const storageKey = "PowerFI_activeTab_" + window.location.pathname;

        bsElements.tabElements.forEach(function (selector) {
            const navLink = document.querySelector(selector + " .nav-link");
            if (navLink) {
                navLink.addEventListener("shown.bs.tab", function () {
                    localStorage.setItem(storageKey, selector);
                });
            }
        });

        const hash = location.hash;
        const tabActivatedViaHash = hash && bsElements.tabElements.includes(hash);

        if (hash) BsElementsExecute(hash);

        if (!tabActivatedViaHash) {
            const savedTab = localStorage.getItem(storageKey);
            if (savedTab && bsElements.tabElements.includes(savedTab)) {
                BsElementsExecute(savedTab, false);
            }
        }
    }

    function BsElementsExecute(candidate, scroll = true) {

        const pathName = window.location.pathname;
        if (candidate?.startsWith(pathName)) candidate = candidate.slice(pathName.length);

        let bsType = false;

        for (const key in bsElements) {
            if (bsElements[key].includes(candidate)) {
                bsType = key;
            }
        }

        if (bsType == false)
            return false;

        if (bsType == "accElements") {
            const accordionItem = $(candidate);
            accordionItem.find(".collapse").collapse("show");
            accordionItem.find(".accordion-button").trigger("focus");
            $("html, body").animate({ scrollTop: accordionItem.offset().top }, 200);
        }
        else if (bsType == "tabElements") {
            const tab = $(candidate);
            const navLink = tab.find(".nav-link");
            navLink.tab("show");
            if (scroll) {
                navLink.trigger("focus");
                $("html, body").animate({ scrollTop: tab.offset().top }, 200);
            }
        }
        else if (bsType == "offcanvasElements") {
            const offcanvas = $(candidate);
            offcanvas.offcanvas("show");
        }

        return true;
    }

    function BsPopovers() {
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => {
            const contentId = popoverTriggerEl.getAttribute('data-bs-content-id');
            const options = { html: true };

            if (contentId) {
                const contentElement = document.getElementById(contentId);
                if (contentElement) {
                    options.content = contentElement.innerHTML;
                }
            }

            return new bootstrap.Popover(popoverTriggerEl, options);
        })
    }

    function BsTooltips() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
    }

    function ClickSupport(selector) {

        selector.on("click", function (e) {

            const href = $(this).attr("href");

            if (BsElementsExecute(href) == true) {
                e.preventDefault();
                return false;
            }

            if (CopyToClipboardExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (ModalsExecute(href, $(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (SpeedBumpExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }
        });
    }

    function CopyToClipboardExecute(clicked) {
        if (!clicked.hasClass("copy")) {
            return false;
        }

        const textToCopy = clicked.text().trim();

        if (!textToCopy) {
            return false;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy).then(function () {
                ShowCopyFeedback(clicked);
            }).catch(function (err) {
                console.error("Failed to copy: ", err);
            });
        } else {
            const textArea = document.createElement("textarea");

            textArea.value = textToCopy;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";

            document.body.appendChild(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
                ShowCopyFeedback(clicked);
            } catch (err) {
                console.error("Failed to copy: ", err);
            }

            document.body.removeChild(textArea);
        }

        return true;
    }

    function DropdownBackdrop() {
        document.addEventListener("show.bs.dropdown", function (e) {
            if (e.target.getAttribute("data-bs-toggle-backdrop") === "false") return;

            ShowDropdownBackdrop();
        });
        document.addEventListener("hide.bs.dropdown", function (e) {
            if (e.target.getAttribute("data-bs-toggle-backdrop") === "false") return;

            HideDropdownBackdrop();
        });
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function IsUriSchema(href) {

        const uriSchemes = ["javascript:", "mailto:", "tel:"];

        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    function HideDropdownBackdrop() {
        document.body.classList.remove("modal-open");

        var backdrop = document.getElementById("dropdown-backdrop");

        if (backdrop) {
            backdrop.classList.remove("show");
            backdrop.addEventListener("transitionend", function () {
                backdrop.remove();
            }, { once: true });
        }
    }

    function Modals() {

        $.ajax({
            type: "GET",
            url: "/Api/Modals/GetModalUrls",
            success: function (result) {
                modals = [...result];
                const href = location.hash.replace("#", "/").toLowerCase();
                ModalsExecute(href, null);
            }
        })
    }

    function ModalsExecute(href, clicked) {

        if (href !== "" && modals.includes(href))
            href = href;
        else
            return false;

        $.ajax({
            type: "GET",
            url: href,
            success: function (result) {

                const modalData = {
                    "id": $(result).filter(".modal, .offcanvas").attr("id"),
                    "content": $(result).filter(".modal, .offcanvas").prop("outerHTML")
                };

                $("body").append(modalData.content);
                const modal = $(`#${modalData.id}`);
                App.Base.ClickSupport(modal.find("a"));

                let showMethod = null;
                let hiddenEvent = null;

                if (modal.hasClass("modal")) {
                    showMethod = "modal";
                    hiddenEvent = "hidden.bs.modal";
                }
                else if (modal.hasClass("offcanvas")) {
                    showMethod = "offcanvas";
                    hiddenEvent = "hidden.bs.offcanvas";
                }

                modal[showMethod]("show").on(hiddenEvent, function () {
                    if (clicked !== null) {
                        clicked.trigger("focus").trigger("blur");
                    }
                    if (!modalFlag) {
                        $(this).remove();
                    }
                });

            }
        });

        return true;
    }

    //function PreventTextOrphans(selector, minimum, wrapperClass) {
    //    App.Plugins.PreventTextOrphans(selector, minimum, wrapperClass);
    //}

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            var $this = $(this);

            if (!$this.hasClass("table")) {
                if (!$this.parents(".rich-text").hasClass("fs-sm")) {
                    $this
                        .addClass("table table-striped table-sticky-first-col")
                        .find("th, td")
                        .each(function () {
                            var $cell = $(this);

                            if (!$cell.attr("colspan")) {
                                $cell.attr("colspan", "1");
                            }

                            if (!$cell.attr("rowspan")) {
                                $cell.attr("rowspan", "1");
                            }
                        });

                    $this
                        .find("tr")
                        .each(function () {
                            var $this = $(this);

                            $this
                                .find("th, td")
                                .first()
                                .addClass("sticky-col");
                    });
                }
            }

            if (!$this.parent().hasClass("table-responsive")) {
                $this.wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    function ShowCopyFeedback(element) {
        const originalTitle = element.attr("title") || "";
        const tooltipInstance = bootstrap.Tooltip.getInstance(element[0]);

        if (tooltipInstance) {
            tooltipInstance.dispose();
        }

        element.attr("data-bs-original-title", "Copied!")
            .attr("title", "Copied!");

        const tooltip = new bootstrap.Tooltip(element[0], {
            trigger: "manual"
        });

        tooltip.show();

        setTimeout(function () {
            tooltip.hide();

            setTimeout(function () {
                tooltip.dispose();

                if (originalTitle) {
                    element.attr("title", originalTitle);
                } else {
                    element.removeAttr("title").removeAttr("data-bs-original-title");
                }
            }, 200);
        }, 1500);
    }

    function ShowDropdownBackdrop() {
        if (document.getElementById("dropdown-backdrop")) return;

        document.body.classList.add("modal-open");

        var backdrop = document.createElement("div");
        backdrop.className = "modal-backdrop fade";
        backdrop.id = "dropdown-backdrop";
        backdrop.style.zIndex = "2";

        document.body.appendChild(backdrop);

        requestAnimationFrame(function () {
            backdrop.classList.add("show");
        });
    }

    function ShowSpeedBump(clicked, href, modalParent) {
        speedBump.modal("show");

        speedBump.find("button[data-speedbump='proceed']")
            .off("click")
            .on("click", function () {
                speedBump.modal("hide");
                window.open(href);
            });

        speedBump.on("hidden.bs.modal", function () {
            clicked.trigger("focus").trigger("blur");

            if (modalFlag) {
                modalParent.modal("show");
                modalFlag = false;
            }
        });
    }

    function SpeedBumpExecute(clicked) {

        const hostname = clicked[0].hostname;
        const href = clicked.attr("href");

        if (hostname === location.hostname || $.inArray(hostname, speedBumpExempt) !== -1 || !href || IsUriSchema(href)) {
            return false;
        }

        const hrefHostname = (() => {
            try {
                return new URL(href, window.location.origin).hostname.toLowerCase();
            } catch {
                return "";
            }
        })();

        const matchingInterruption = serviceInterruptions.find(si => {
            if (!si.Urls || si.Urls.length === 0 || !hrefHostname) return false;

            return si.Urls.some(url => {
                if (!url) return false;

                try {
                    const configuredHostname = new URL(url.includes("://") ? url : `https://${url}`).hostname.toLowerCase();
                    return hrefHostname === configuredHostname || hrefHostname.endsWith(`.${configuredHostname}`);
                } catch {
                    return false;
                }
            });
        });

        // check to see if speedbump was triggered from a modal
        const modalParent = clicked.parents(".modal").first();
        modalFlag = modalParent.length != 0;
        modalParent.modal("hide");

        if (matchingInterruption) {
            // Show ServiceInterruption modal instead of speedbump
            // Use the first URL to generate the modal ID
            const firstUrl = matchingInterruption.Urls[0];
            const modalId = "ServiceInterruption_" + firstUrl.replace(/[^a-zA-Z0-9]/g, "_");
            const serviceInterruptionModal = $("#" + modalId);

            if (serviceInterruptionModal.length > 0) {
                serviceInterruptionModal.modal("show");
                serviceInterruptionModal.find("button[data-speedbump='proceed']")
                    .off("click")
                    .on("click", function () {
                        serviceInterruptionModal.modal("hide");
                        window.open(href);
                    });

                serviceInterruptionModal.on("hidden.bs.modal", function () {
                    clicked.trigger("focus").trigger("blur");

                    if (modalFlag) {
                        modalParent.modal("show");
                        modalFlag = false;
                    }
                });
            } else {
                // Fallback to speedbump if modal not found
                ShowSpeedBump(clicked, href, modalParent);
            }
        } else {
            // Show standard speedbump modal
            ShowSpeedBump(clicked, href, modalParent);
        }

        return true;
    }

    function Year() {
        var $year = $(".year");

        $.each($year, function () {
            var $this = $(this),
                year = new Date().getFullYear();

            $this.text(year);
        });
    }

    return {
        Animations: Animations,
        Autofocus: Autofocus,
        BsElements: BsElements,
        BsPopovers: BsPopovers,
        BsTooltips: BsTooltips,
        ClickSupport: ClickSupport,
        DropdownBackdrop: DropdownBackdrop,
        GetUrlParameter: GetUrlParameter,
        HideDropdownBackdrop: HideDropdownBackdrop,
        Modals: Modals,
        //PreventTextOrphans: PreventTextOrphans,
        RichTextResponsiveTables: RichTextResponsiveTables,
        ShowDropdownBackdrop: ShowDropdownBackdrop,
        Year: Year
    };

})(jQuery);

$(function () {
    App.Base.Animations();
    App.Base.Autofocus();
    App.Base.BsElements();
    App.Base.BsPopovers();
    App.Base.BsTooltips();
    App.Base.DropdownBackdrop();
    App.Base.Modals();
    App.Base.ClickSupport($("a"));
    //App.Base.PreventTextOrphans($("h1, h2, h3, h4, h5, h6, .enable-pto"));
    App.Base.RichTextResponsiveTables($(".rich-text table"));
    App.Base.Year();
});